// extracted by mini-css-extract-plugin
export default {"root":"_30htH","flames":"J30-V","flame":"_xLvh"};